<template>
    <input ref="inputElement" type="text" class="form-control" />
</template>

<script setup lang="ts">
    import type { IMultiLanguageText } from "@/data/model/Shared";
    import { MultiLanguageInput } from "@/portal/formControls/MultiLanguageInput";
    import { onMounted, ref, watch } from "vue";

    const model = defineModel<IMultiLanguageText | undefined>({ required: true });
    const inputElement = ref<HTMLInputElement | null>(null);

    let multiLanguageInput: MultiLanguageInput | undefined;
    onMounted(() => {
        if (inputElement.value) {
            multiLanguageInput = MultiLanguageInput.fromInput($(inputElement.value!));
            multiLanguageInput.setValues(model.value === undefined ? undefined : model.value);
            multiLanguageInput.onChange = (value) => {
                model.value = value;
            };
        }
    });

    watch(model, (value) => {
        multiLanguageInput?.setValues(value === undefined ? undefined : value);
    });

    function setError(hasError: boolean) {
        multiLanguageInput?.setError(hasError);
    }

    defineExpose({
        setError,
    });
</script>
